import { useTellescopeQuery } from "@tellescope/tanstack-query";

export interface StripeSetupIntentResponse {
  clientSecret: string;
  publishableKey: string;
}

interface UseStripeSetupIntentOptions {
  enabled?: boolean;
  refetchOnMount?: boolean | "always";
}

/**
 * Hook to fetch a Stripe SetupIntent for updating payment methods.
 * The SetupIntent allows collecting payment details without charging.
 *
 * By default, this query is disabled and must be explicitly enabled.
 * Use `refetchOnMount: 'always'` to ensure a fresh SetupIntent each time
 * the dialog opens.
 */
export function useStripeSetupIntent(options: UseStripeSetupIntentOptions = {}) {
  const { enabled = false, refetchOnMount = "always" } = options;

  return useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: {
      integration: "Stripe",
      type: "setup-intent",
    },
    enabled,
    staleTime: 0, // Always fetch fresh for security
    gcTime: 0, // Don't cache - each SetupIntent should be fresh
    refetchOnMount,
    select: (response) => response?.data as StripeSetupIntentResponse,
  });
}
